import { DEVICE_UPDATE_ERROR } from "./codes.constants.error";
import ApiError from "../../errors/ApiError";

export class DeviceUpdateError extends ApiError {
  constructor() {
    super(DEVICE_UPDATE_ERROR);
  }
}
